import { render, staticRenderFns } from "./PlatformPolicies.vue?vue&type=template&id=2ef0b828&scoped=true"
import script from "./PlatformPolicies.vue?vue&type=script&lang=js"
export * from "./PlatformPolicies.vue?vue&type=script&lang=js"
import style0 from "./PlatformPolicies.vue?vue&type=style&index=0&id=2ef0b828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef0b828",
  null
  
)

export default component.exports